import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Constants } from './core/config/Constants';
import { Observable } from 'rxjs/Observable';
import { UtilityService } from './core/services/utility.service';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { ExtraService } from './core/services/extra.service';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  
  isLogin :boolean = false;
  showStyle: false;
  isShow :boolean;
  getMargin() {
    if(!this.isShow) {
      return "0px";
    } else {
      return "";
    }
  }
  constructor(private angularFireAuth:AngularFireAuth,private extraService:ExtraService,private router: Router,private utilityService: UtilityService) { 
  }
  ngOnInit(): void {
     this.extraService.changeStateLogin();
    this.extraService.cast$.subscribe(isShow=>{
      setTimeout(()=>{
        this.isShow = isShow;
      });});
     this.extraService.castLogin$.subscribe(
      isLogin=>{
        setTimeout(()=>{
          this.isLogin = isLogin;
        });});
        
      if (this.utilityService.isLogged()) {
        this.isLogin = true;
      }else{
        this.isLogin = false;
        this.router.navigate([Constants.LOGIN_URL]);
      } 
  }
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/app.component.ts